import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor() { }

  convertToDDMMYYYY(date){

  }

  convertToYYYYMMDD(date){
    if(typeof(date) == 'string'){
      date = new Date(date);
    }

    return date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate()
    
  }

  refineDate(date){
    

    let refinedDate =date;

    if(typeof(date) == 'string' && date.includes('.')){
      refinedDate = refinedDate.split('.')[0];
      refinedDate = refinedDate.split('T')[0] +' '+refinedDate.split('T')[1];
    } 

    return refinedDate;
  }
}
